import { SalesPackingList } from './SalesPackingList';
import { SalesPackingCreate } from './SalesPackingCreate';
import { SalesPackingEdit } from './SalesPackingEdit';

export default {
  list: SalesPackingList,
  create: SalesPackingCreate,
  edit: SalesPackingEdit,
};
